import React from "react";
import { Helmet } from "react-helmet-async";

const PolicyScreen = () => {
  return (
    <div className="min-h-screen bg-gray-100">
      <Helmet>
        <title>Chính Sách Quyền Riêng Tư | AutoWork</title>
        <meta
          name="description"
          content="Chính sách quyền riêng tư của AutoWork về thu thập, xử lý và bảo vệ dữ liệu khi sử dụng dịch vụ tự động hóa nội dung."
        />
        <link rel="canonical" href="https://autowork.com.vn/policy" />
        <meta property="og:type" content="article" />
        <meta property="og:url" content="https://autowork.com.vn/policy" />
        <meta
          property="og:title"
          content="Chính Sách Quyền Riêng Tư | AutoWork"
        />
        <meta
          property="og:description"
          content="Thông tin chi tiết về bảo mật và quyền riêng tư khi sử dụng AutoWork."
        />
      </Helmet>
      <div className="container mx-auto px-4 py-8 max-w-4xl">
        <div className="bg-white rounded-lg shadow-lg p-6">
          <h1 className="text-3xl font-bold text-center text-blue-600 mb-8">
            CHÍNH SÁCH QUYỀN RIÊNG TƯ - AUTOWORK
          </h1>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              1. Giới thiệu
            </h2>
            <p className="text-gray-600 leading-relaxed">
              AUTOWORK cam kết bảo vệ quyền riêng tư của bạn. Chính sách này
              giải thích cách chúng tôi thu thập, sử dụng, chia sẻ và bảo vệ
              thông tin cá nhân của bạn khi bạn sử dụng dịch vụ quản lý và tự
              động hóa nội dung fanpage của chúng tôi ("Dịch vụ").
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              2. Thông tin chúng tôi thu thập
            </h2>
            <p className="text-gray-600 mb-4">
              Chúng tôi thu thập các loại thông tin sau:
            </p>

            <h3 className="text-xl font-medium text-gray-700 mb-3">
              2.1. Thông tin bạn cung cấp trực tiếp:
            </h3>
            <div className="text-gray-600 space-y-4 mb-6">
              <p>
                <strong>Thông tin tài khoản AUTOWORK:</strong> Khi bạn đăng ký
                sử dụng Dịch vụ, chúng tôi có thể yêu cầu bạn cung cấp tên người
                dùng, địa chỉ email và mật khẩu (được mã hóa).
              </p>

              <p>
                <strong>Thông tin thanh toán:</strong> Nếu bạn chọn sử dụng các
                tính năng trả phí của Dịch vụ, chúng tôi sẽ thu thập thông tin
                thanh toán cần thiết, chẳng hạn như số thẻ tín dụng hoặc thông
                tin tài khoản ngân hàng và lịch sử giao dịch.
              </p>

              <p>
                <strong>Thông tin fanpage được kết nối:</strong> Để cung cấp
                Dịch vụ, chúng tôi yêu cầu bạn cấp quyền truy cập vào fanpage
                Facebook của bạn thông qua API của Facebook. Chúng tôi KHÔNG lưu
                trữ thông tin đăng nhập Facebook của bạn.
              </p>

              <p>
                <strong>Nội dung bạn cung cấp:</strong> Bao gồm văn bản, hình
                ảnh, video, liên kết và bất kỳ thông tin nào khác mà bạn cung
                cấp để Dịch vụ tạo và lên lịch đăng bài.
              </p>

              <p>
                <strong>Cài đặt tùy chỉnh cho AI:</strong> Chủ đề, giọng văn,
                hình ảnh, thời gian và các tùy chọn khác mà bạn thiết lập.
              </p>
            </div>

            <h3 className="text-xl font-medium text-gray-700 mb-3">
              2.2. Thông tin thu thập tự động:
            </h3>
            <div className="text-gray-600 space-y-4 mb-6">
              <p>
                <strong>Thông tin thiết bị:</strong> Loại thiết bị, hệ điều
                hành, ID thiết bị duy nhất, địa chỉ IP và nhà cung cấp dịch vụ
                di động.
              </p>

              <p>
                <strong>Dữ liệu nhật ký:</strong> Thời gian truy cập, các trang
                hoặc tính năng đã sử dụng, các lỗi gặp phải và hoạt động hệ
                thống khác.
              </p>

              <p>
                <strong>Cookies và công nghệ theo dõi:</strong> Sử dụng để ghi
                nhớ thông tin đăng nhập, cá nhân hóa trải nghiệm và phân tích
                lưu lượng truy cập.
              </p>

              <p>
                <strong>Thông tin tương tác trên fanpage:</strong> Thu thập
                thông tin về các tương tác (lượt thích, bình luận, chia sẻ)
                thông qua API của Facebook.
              </p>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              3. Cách chúng tôi sử dụng thông tin
            </h2>
            <div className="text-gray-600 space-y-4">
              <p>
                <strong>Cung cấp và duy trì Dịch vụ:</strong> Vận hành và duy
                trì các tính năng của AUTOWORK.
              </p>
              <p>
                <strong>Cải thiện và cá nhân hóa:</strong> Điều chỉnh Dịch vụ
                theo sở thích của bạn.
              </p>
              <p>
                <strong>Phân tích hiệu suất:</strong> Theo dõi và phân tích
                tương tác để cải thiện thuật toán AI.
              </p>
              <p>
                <strong>Liên lạc:</strong> Gửi thông báo về Dịch vụ và hỗ trợ kỹ
                thuật.
              </p>
              <p>
                <strong>Xử lý thanh toán:</strong> Quản lý các giao dịch và tài
                khoản của bạn.
              </p>
              <p>
                <strong>Tuân thủ pháp luật:</strong> Đáp ứng các yêu cầu pháp lý
                khi cần thiết.
              </p>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              4. Bảo mật thông tin
            </h2>
            <div className="text-gray-600 space-y-4">
              <p>
                Chúng tôi áp dụng các biện pháp bảo mật kỹ thuật và tổ chức mạnh
                mẽ để bảo vệ thông tin của bạn:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Mã hóa dữ liệu trong quá trình truyền và lưu trữ</li>
                <li>Kiểm soát truy cập chặt chẽ với nhân viên</li>
                <li>Giám sát hệ thống 24/7</li>
                <li>Đánh giá rủi ro bảo mật định kỳ</li>
                <li>Tuân thủ các tiêu chuẩn bảo mật ngành</li>
              </ul>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              5. Quyền của người dùng
            </h2>
            <div className="text-gray-600 space-y-4">
              <p>Bạn có các quyền sau đối với thông tin cá nhân của mình:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Quyền truy cập và xem thông tin</li>
                <li>Quyền chỉnh sửa thông tin không chính xác</li>
                <li>Quyền xóa thông tin trong một số trường hợp</li>
                <li>Quyền hạn chế xử lý thông tin</li>
                <li>Quyền phản đối việc xử lý thông tin</li>
                <li>Quyền di chuyển dữ liệu</li>
              </ul>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              6. Trách nhiệm đối với nội dung do AI tạo ra
            </h2>
            <div className="text-gray-600 space-y-4">
              <p>
                <strong>Người dùng chịu trách nhiệm:</strong> Khi sử dụng dịch
                vụ của AUTOWORK, bạn xác nhận và đồng ý rằng bạn hoàn toàn chịu
                trách nhiệm về nội dung do AI tạo ra thông qua việc sử dụng Dịch
                vụ của chúng tôi và được đăng lên các nền tảng mạng xã hội hoặc
                website của bạn.
              </p>
              <p>
                <strong>Kiểm duyệt nội dung:</strong> Mặc dù AUTOWORK cung cấp
                công cụ tự động hóa nội dung bằng AI, bạn có trách nhiệm kiểm
                tra, chỉnh sửa và phê duyệt nội dung trước khi nó được đăng lên
                nền tảng của bạn. Chúng tôi khuyến nghị bạn nên kiểm tra tất cả
                nội dung được tạo tự động trước khi cho phép đăng.
              </p>
              <p>
                <strong>Tuân thủ pháp luật và quy định:</strong> Bạn phải đảm
                bảo rằng nội dung được đăng tuân thủ tất cả các luật áp dụng và
                các chính sách của nền tảng mà nội dung được đăng lên. AUTOWORK
                không chịu trách nhiệm về bất kỳ vi phạm nào do nội dung của bạn
                gây ra.
              </p>
              <p>
                <strong>Miễn trừ trách nhiệm:</strong> AUTOWORK không chịu trách
                nhiệm về bất kỳ hậu quả pháp lý, tổn thất tài chính, hoặc thiệt
                hại danh tiếng nào phát sinh từ việc sử dụng nội dung do AI tạo
                ra thông qua Dịch vụ của chúng tôi.
              </p>
              <p>
                <strong>Phản hồi và báo cáo:</strong> Nếu bạn phát hiện ra bất
                kỳ nội dung không phù hợp hoặc có vấn đề nào do hệ thống AI của
                chúng tôi tạo ra, vui lòng báo cáo ngay để chúng tôi có thể cải
                thiện dịch vụ.
              </p>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              7. Thông tin liên hệ
            </h2>
            <div className="text-gray-600">
              <p className="mb-4">
                Nếu bạn có bất kỳ câu hỏi nào về Chính sách Quyền riêng tư này,
                vui lòng liên hệ với chúng tôi:
              </p>
              <ul className="space-y-2">
                <li>
                  <strong>Email:</strong> autowork365@gmail.vn
                </li>
                <li>
                  <strong>Điện thoại:</strong> 0394.932.696
                </li>
                <li>
                  <strong>Địa chỉ:</strong> Hòa Phát, Cẩm Lệ, Đà Nẵng
                </li>
              </ul>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PolicyScreen;
